import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lessons',
  templateUrl: '../views/lessons.component.html',
  styleUrls: ['../../../css/lessons.component.css','../../../css/paper-sets.component.css']
})
export class LessonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/lessons/components/lessons.component.ts